
<div class="row" style="width:100%;">
<div class="col-4">
    <mat-form-field style="width:98%;">
        <mat-label>Select Search Criteria</mat-label>
        <mat-select [(value)]="selected"  (selectionChange)="onDateTypePickerSelectionChange($event)">
          <mat-option value="today">Today</mat-option>
          <mat-option value="yesterday">Yesterday</mat-option>
          <mat-option value="7days">Last 7 Days</mat-option>
          <mat-option value="30days">Last 30 Days</mat-option>
          <mat-option value="mtd">Current Month</mat-option>
          <mat-option value="previousmonth">Previous Month</mat-option>
          <mat-option value="currentyear">Current Year</mat-option>
          <mat-option value="specificdate">Specific Date</mat-option>
          <mat-option value="daterange">Date Range</mat-option>
        </mat-select>
      </mat-form-field>
 </div>
 <div class="col-8">
    @if(selected == 'specificdate'){
        <mat-form-field style="width:100%;">
            <mat-label>Choose a date</mat-label>
            <input matInput [matDatepicker]="picker" [formControl]="dateSelectControl" DateToCurrentYearStandalone/>
            <mat-hint>MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
    }
    @else if(selected == 'daterange'){
        <mat-form-field style="width:100%;">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [formGroup]="rangeForm" [rangePicker]="rangepicker" >
              <input matStartDate formControlName="start" placeholder="Start date" DateToCurrentYearStandalone>
              <input matEndDate formControlName="end" placeholder="End date" DateToCurrentYearStandalone>
            </mat-date-range-input>
            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="rangepicker" ></mat-datepicker-toggle>
            <mat-date-range-picker #rangepicker></mat-date-range-picker>
          
            @if (rangeForm.controls.start.hasError('matStartDateInvalid')) {
              <mat-error>Invalid start date</mat-error>
            }
            @if (rangeForm.controls.end.hasError('matEndDateInvalid')) {
              <mat-error>Invalid end date</mat-error>
            }
          </mat-form-field>
          
    }
</div>
<div class="row" style="width:100%;">
    <div class="col-6">
        <div style="margin-left:10px;">
            <span>{{fromDate | date: 'shortDate'}} to {{toDate | date: 'shortDate'}}</span>
            @if(rangeErrorMessage != ''){
                <br />
            <span style="color:red;">{{rangeErrorMessage}}</span>
            }
        </div>
    </div>
</div>

</div>

